const sortConversationsByDate = conversations => conversations.sort((convA, convB) => Date.parse(convB.lastMessageDate) - Date.parse(convA.lastMessageDate));
export default sortConversationsByDate;
//# sourceMappingURL=sortConversationsByDate.js.map